'use strict'

let issueTypes={
  change: "Request for change",
  specification: "Off-specification",
  problem: "Problem / concern"
};

let impact="Impact";
let options="Options";
let recommendation="Recommendation";
let decision="Decision";

export let english={
  general: {
    approach: "approach",
    examineDetails: {
      typeValues: issueTypes,
      description: "Description"
    },
    proposeDetails: {
      impact: "Impact"
    },
    decideDetails: {
      options: options,
      recommendation: recommendation
    },
    implementDetails: {
      decision: decision
    },
    title: "Change",
    priority: "Priority",
    severity: "Severity",
    addIssue: "Add Issue",
    noIssues: "No issues in register",
    documentIssue: "Press \"Add issue\" if you have a change request, an off-specification or a problem/concern to be documented.",
    status: {
      captured: "Captured",
      examined:"Analyze impact",
      proposed: "Consider options",
      decided: "Await decision",
      implemented: "Follow up"
    }
  },
  report: {
    cancel: "Cancel",
    publishReport: "Publish report",
    publishInProgress: "... publish ongoing ...",
    lastIssueReports: "Most Recent Reports",
    columns: {
      id: "Id",
      title:"Title",
      impact: impact,
      recommendation: "Recommendation",
      decision: decision,
      status: "Status"
    },
    menu: {
      issueOptions: "Issue Options",
      createIssueReport: "Create Issue Report",
      createExceptionReport: "Create Exception Report",
      issueReports: "Reports",
      noReports: "No reports are available",
      whenToUseReports: "When to use Reports: ",
      whenToUseReportsIngress: " Use a report when something unplanned occurs and there is a need to inform the Project Board",
      whenToUseIssueReport: "Use Issue Report when you need to keep the Project Board informed or need to ask the Project Board for advice.",
      whenToUseExceptionReport: "Use Exception Report if you need a formal decision from the Project Board."
    }
  },
  issue: "Issue",
  Capture: {
    title: "Capture",
    fields: {
      title: {
        title: "Title",
        description:"Descriptive issue title",
        help:"Short summary of the issue"
      },
      type: {
        title: "Issue Type",
        help:`What is the nature of the issue raised?

Request for change:
Proposal for a change to a baseline
New requirements, added scope etc.

Off-specification:
Something is not delivered according to the specifications agreed
Something is not reviewed and approved as agreed

Problem/concern:
Other issue to resolve or escalate`,

        options: issueTypes
      },
      description: {
        title: "Description",
        description:"The background and nature of the issue",
        help:"What is the context, the background, the trigger and the nature of the issue?",
      }
    }
  },
  Examine: {
    title: "Examine",
    fields:{
      impact: {
        title: impact,
        description:"Describe impact on objectives, business case and risk",
        help:`What impact does the issue have on:

Time, cost, quality and scope
Business Case and benefits
Other dependent deliverables
Risk profile`
      },
      severity: {
        title: "Severity",
        help:`What is the level of impact on objectives?

Severe: Critical objective(s) will not be achieved
Significant: Stated objective(s) will fall below acceptable level
Moderate: Stated objective(s) will fall below goals but above minimum acceptable levels
Minor: Stated objective(s) will fall below goals but well above minimum acceptable levels
Negligible: No or little impact on achieving objectives`,
        options: {
          1: "Negligible",
          2: "Minor",
          3: "Moderate",
          4: "Significant",
          5: "Severe"
        }
      },
      priority: {
        title: "Priority",
        help:"How high is the urgency of getting this issue resolved?",
        options: {
          1: "Very Low",
          2: "Low",
          3: "Medium",
          4: "High",
          5: "Very High"
        }
      }
    }
  },
  Propose: {
    title: "Propose",
    fields: {
      options: {
        title: options,
        description:"List the options identified",
        help:"What alternatives have been considered? Has the effect of each option on time, cost, quality, scope, benefits and risk been evaluated?",
      },
      recommendation: {
        title: recommendation,
        description:"Describe the proposed corrective action and why this is the team's recommendation",
        help:"Which option amongst the alternatives has the best balance between advantage gained and time/cost/risk of implementation? ",
      },
      lessonSummary: {
        title: "Lessons Learned (will only show in Exception Report, not in Issue Report)",
        description: "Summary of lessons learned.",
        help: "What did we learn from this issue? Could we have avoided or limited this issue? Could we have dealt with this issue in a better way?"
      }
    }
  },
  Decide: {
    title: "Decide",
    fields: {
      decision: {
        title: decision,
        description:"Describe what was decided, where, how, when..",
        help:"What was decided? Where and when was it decided? In a meeting, by e-mail?",
      },
      decidedBy: {
        title: "Decision made by",
        description:"The name of the final decision maker",
        help:"Who made the final decision? When? Anyone else consulted or included?"
      }
    }
  },
  Implement: {
    title: "Implement",
    fields: {
      status: {
        title: "Status",
        options: {
          Active: "Active",
          Closed: "Closed"
        }
      },
      statusDescription: {
        title: "Description of current status"
      }
    }
  },
  issueRegister: {
    title: "Issue Register",
    description: "The Issue Register is used to capture and maintain information on all of the issues that are being managed formally. All change requests, off-specifications and problems where a formal decision process is needed, should be documented as an issue. ",
    description2: "Add a new issue by selecting 'Add Issue' below. You can maintain an issue by selecting it in the table below."
  },
  changeControlApproach: {
    title: "Change Control Approach",
    description: "The change control approach describes how changes and issues arising will be managed. What will we do to make sure we have sufficient control of changes?",
    fields: {
      process: {
        title: "Process and Procedures",
        help: `How will problems or change requests be captured, recommendations developed and decisions made? For small changed, for large changes?
          Are there any standard procedures to be followed on change control and issue management?
          Any planned deviation from these procedures? If so, why?
          How will we make sure the procedure is followed - that approvals are tracked?
          Any standards or templates to be used?
          How will the change process work with 3rd parties?`,
        description: "Describe what processes the project will follow to make sure all changes and concerns are managed well"
      },
      tools: {
        title: "Tools and Techniques",
        help: `Which techniques and tools will be used to capture and manage problems and change requests?
          Which techniques and tools will be used to control versioning of documents, code, drawings, requirements, marketing material, user instructions, training material, plans, team plans etc?
          Will an issue register be used? If yes, is it the only tool used to track change actions and approvals? If no, what will be used instead or in addition?
          Any tools or techniques used by 3rd parties involved?`,
        description: "Describe what tools or techniques will be applied to make sure all changes and issues are identified, assessed, solutions proposed and decisions made"
      },
      reporting: {
        title: "Reporting",
        help: `When will issues/changes be reported?
          Where will issues/changes be reported and who will receive the issue reports?`,
        description: "The issue reports to be produced, their purpose, timing and recipients"
      },
      timing: {
        title: "Timing of activities",
        help: `When will change control and issue management activities occur?
          Any specific activities in Initiation or beginning/end of stages?`,
        description: "Describe the timing of change control and issue management activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: `Who is responsible for the change control and issue management procedure? Who makes sure the project complies?
          Who approves which kinds of changes?
          Who should report issues and changes and to whom?`,
        description: "Define the roles and responsibilities for the activities"
      },
      scales: {
        title: "Scales of severity and priority",
        help: `Who can make decisions on which level of issue severity and priority?
          Should the program, project or team manager(s) have any change authority on any of these levels?`,
        description: "Define who can make decisions on the various levels of issue severity and priority"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/change/labels/english.js